import { FETCH_ADMIN_SATUAN_LIST, RECEIVE_ADMIN_SATUAN_LIST, FAILED_ADMIN_SATUAN_LIST  } from '../../actions/satuan/aSatuan-AdminSatuanList'

const defaultAdminSatuanListState = {
    adminSatuanData: [],
    adminList:[],
    superAdminList : []
    
}

export function fetchAdminList(state = defaultAdminSatuanListState, action){
    switch (action.type) {
        case FETCH_ADMIN_SATUAN_LIST:
            return ({adminSatuanData: [],adminList:[], superAdminList:[], inProgress: true})
        case RECEIVE_ADMIN_SATUAN_LIST:
            var superAdminList = action.payload.filter(x => x.roles_name === "super admin")
            var adminList = action.payload.filter(x => x.roles_name ==="admin")
            return Object.assign({}, state, {adminSatuanData: action.payload, adminList:adminList, superAdminList:superAdminList,inProgress: false})
        case FAILED_ADMIN_SATUAN_LIST:
            return ({adminSatuanData: [],adminList:[], superAdminList:[], inProgress: false})
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/satuan/redSatuan-AdminSatuanList.jsx